<template>
  <div class="layout" ref="Layout">
    <a-back-top>
      <div class="antd-back-top"><a-icon type="caret-up" /></div>
    </a-back-top>
    <Header :key="`header-top-${$store.state.loginStateKey}`" class="header_visible" />
    <div id="LayoutHeader" ref="BackTopDom" />
    <!-- AntBlockSkeleton 不加入骨架屏,获取权限刷新页面会重复发送请求 -->
    <AntBlockSkeleton height="50rem" :loading="!$store.state.loginStateKey">
      <div class="router_view"><keep-alive :include="include"><router-view :key="$store.state.loginStateKey" /></keep-alive></div>
    </AntBlockSkeleton>
    <Footer v-show="($route.path != '/standard') && ($route.path != '/detailsPage/benchmarking')" />
    <Login v-if="$store.state.visibleLogin" @onOff="onOff" />
  </div>
</template>

<script>
import Header from './header';
import Footer from './footer';
import Login from '@/views/login';
export default {
  components: { Header, Footer, Login },
  data() {
    return {
      visible: true,
      subsidiary: this.$FN.elVisible(this.fn, { visible: true, rootMargin: "0px" }),
      dom: null,
      include: "home,comprehensiveSearch", // 需要缓存的组件
      footerShow: false
    }
  },
  watch: {
    '$route': {
      deep: true,
      handler: function () { this.dom && this.scrollTop() }
    }
  },
  created() {
    this.$FN.occurSimultaneously()
  },
  mounted() {
    this.getRef();
    this.getMainDom();
    this.seFooterShow();
    // this.encryptedMediaExtensions();
  },
  methods: {
    // 防止截屏录屏
    // encryptedMediaExtensions() {

    // },
    onOff(value = false) {
      this.$store.commit('setVisibleLogin', value);
    },
    getRef() {
      let fn = () => {
        let refs = this.$refs.BackTopDom;
        this.subsidiary(refs);
      };
      fn();
    },
    fn(_, flag) { this.visible = flag },
    // 让页脚最后在渲染
    seFooterShow() {
      let time = setTimeout(() => {
        this.footerShow = true;
        clearTimeout(time);
        time = null;
      }, 1000);
    },
    getMainDom() {
      this.dom = this.$refs.BackTopDom
    },
    scrollTop() {
      this.dom && this.dom.scrollIntoView({ behavior: "instant", block: "center" });
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>